const byIds = {};

export class ProposalStatus {
  constructor(id) {
    this.id = id;
    byIds[id] = this;
  }

  equals(object) {
    if (typeof object === 'string') {
      return this.id === object;
    } else if (typeof object === 'object' && object.hasOwnProperty('id')) {
      return this.id === object.id;
    } else {
      return false;
    }
  }

  static getById(id) {
    if (byIds[id]) {
      return byIds[id];
    }
    return null;
  }
}

ProposalStatus.WAITING = new ProposalStatus('waiting');
ProposalStatus.APPROVED = new ProposalStatus('approved');
ProposalStatus.REJECTED = new ProposalStatus('rejected');
ProposalStatus.WITHDRAWN = new ProposalStatus('withdrawn');



// WEBPACK FOOTER //
// ./src/domain/proposal-status-enum.js